import React from "react";
import { PrincipalFormData, PrincipalFormErrors } from "../types";

interface AccountInformationFormProps {
  formData: PrincipalFormData;
  formErrors: PrincipalFormErrors;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  isEditMode?: boolean;
}

const AccountInformationForm: React.FC<AccountInformationFormProps> = ({
  formData,
  formErrors,
  onChange,
  isEditMode = false,
}) => {
  return (
    <div className="bg-white rounded-xl p-6 flex flex-col justify-start min-h-[120px] transition-shadow duration-200 transition-colors border-[1px] border-cardborder">
      <h2 className="text-lg font-semibold mb-4">
        Account Information
      </h2>
      <div className="space-y-6">
        {/* Email and Password Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email <span className="text-red-500">*</span>
            </label>
            {isEditMode ? (
              <p className="block w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-700">
                {formData.email || "—"}
              </p>
            ) : (
              <>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={onChange}
                  placeholder="Enter Email"
                  className={`block w-full px-3 py-2 border ${formErrors.email ? 'border-red-500' : 'border-gray-300'} rounded-md bg-white text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand`}
                />
                {formErrors.email && (
                  <div className="text-red-500 text-sm mt-1">
                    {formErrors.email}
                  </div>
                )}
              </>
            )}
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
              {isEditMode ? (
                <>Password</>
              ) : (
                <>Password <span className="text-red-500">*</span></>
              )}
            </label>
            {isEditMode ? (
              <p className="block w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-700">
                ••••••••
              </p>
            ) : (
              <>
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={onChange}
                  placeholder="Enter Password"
                  className={`block w-full px-3 py-2 border ${formErrors.password ? 'border-red-500' : 'border-gray-300'} rounded-md bg-white text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand`}
                />
                {formErrors.password && (
                  <div className="text-red-500 text-sm mt-1">
                    {formErrors.password}
                  </div>
                )}
              </>
            )}
            {isEditMode && (
              <p className="text-sm text-gray-500 mt-1">
                Account information cannot be modified
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountInformationForm;
